// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"428":"assets/css/admin","433":"assets/css/chat","504":"assets/css/front","574":"assets/css/user"}[chunkId] + ".css";
};